import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; Award Web and Design Services</p>
      </div>
    </footer>
  );
};

export default Footer; 